export class Payment {
  id: string;
  amount: number;
  description: string;
  emailUser: string;
  billingDate: Date;
  dueDate: Date;
  invoiceId: string;
  urlBilling: string;
  status: string;
}

export function interpretServerPayment(sp: any): Payment {
  const p = new Payment();
  p.id = sp.idPayments || sp.id;
  p.description = sp.description;
  p.emailUser = sp.emailUser;
  p.urlBilling = sp.urlBilling;
  p.status = sp.status;
  p.amount = sp.amount;
  p.invoiceId = sp.invoiceId;
  p.dueDate = new Date(sp.dueDate);
  p.billingDate = new Date(sp.billingDate);
  return p;
}

export function sortPaymentsByDueDate(list: Payment[], newerFirst = true) {
  return list.sort((prev, next) => {
    if (prev.id == next.id || prev.dueDate.toISOString() == next.dueDate.toString()) {
      return 0;
    }
    return (newerFirst ? 1 : -1) * (prev.dueDate > next.dueDate ? 1 : -1);
  })
}
